import {
  Component,
  OnInit,
  HostListener,
  OnChanges
} from '@angular/core';

import { Router } from '@angular/router';

import {
  CommonService,
  ApiUrlConstants,
  ApiService,
  LoaderService
} from '../../../shared/utils/imports';

import { HttpClient } from '@angular/common/http';

import {
  NotificationSignalRService
} from 'src/app/shared/services/notification-signalr.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent
  implements OnInit, OnChanges {

  public logoutClicked = false;

  public showInternalTab;
  public showExternalTab;

  public logoutHeader = false;

  public userType;

  public userName = '';

  public notificationsList: any[];

  public userID =
    this.common.getUserID();

  public notificationData = {
    totalUnreadRecords: 0
  };

  public totalUnreadRecords = 0;

  public notificationBar = false;

  public showNotificationOnetime = false;

  public APItimeOUT;

  public toasterTimeout;

  public notificationCount;

  public previousUrl;

  public showimage = false;

  public signaldata: any[] = [];


  constructor(
    private readonly router: Router,
    private readonly common: CommonService,
    private readonly api: ApiService,
    public readonly loader: LoaderService,
    private http: HttpClient,
    private readonly signalRService:
      NotificationSignalRService
  ) {

    this.checkPageType();

    this.userName =
      this.common.getUsername();
  }


  ngOnChanges() {

    console.log(
      'ngOnChanges'
    );
  }


  /**
   * Set internal/external header
   */
  public checkPageType() {

    this.userType =
      this.common.getUserType();

    if (this.userType === 'Internal') {

      this.common.setInternalHeader(true);

      this.common.setExternalHeader(false);

    } else if (
      this.userType === 'External'
    ) {

      this.common.setInternalHeader(false);

      this.common.setExternalHeader(true);
    }
  }


  ngOnInit() {

    this.notificationBar = false;


    /**
     * =====================================================
     * SIGNALR
     * =====================================================
     *
     * Header does NOT create SignalR connection.
     *
     * AppComponent starts the connection.
     *
     * Header only subscribes to notifications.
     */

    this.signalRService.notification$
      .subscribe(message => {      


        this.signaldata.push(message);       


        /**
         * Check whether notification belongs
         * to current user
         */
        if (
          this.userID ==
          message.receiverId
        ) {          

          this.notificationData =
            message;


          this.totalUnreadRecords =
            message.totalUnreadRecords;


          this.notificationBar = true;

          this.showimage = true;


          this.common.signalTotalCountSource
            .next(
              message.totalUnreadRecords
            );


          this.common.signalShowImageSource
            .next(true);


          this.common.signalNotificationBarSource
            .next(true);


          /**
           * Update session storage
           */
          sessionStorage.setItem(
            'unreadNotification',
            message.totalUnreadRecords
          );


          this.closeNotificationInterval();

        } else {

          // console.log(
          //   'Notification does not belong to current user.'
          // );
        }
      });


    /**
     * Existing notification count subscription
     */
    this.common.signalTotalCountCheck
      .subscribe(value => {

        this.totalUnreadRecords =
          value;
      });


    /**
     * Existing notification image subscription
     */
    this.common.signalShowImageCheck
      .subscribe(value => {

        this.showimage =
          value;
      });


    /**
     * Existing notification bar subscription
     */
    this.common.signalNotificationBarCheck
      .subscribe(value => {

        this.notificationBar =
          value;
      });


    /**
     * External header
     */
    this.common.externalHeaderCheck
      .subscribe(value => {

        this.showExternalTab =
          value === true
            ? this.userType === 'External'
              ? true
              : false
            : false;
      });


    /**
     * Internal header
     */
    this.common.internalHeaderCheck
      .subscribe(value => {

        this.showInternalTab =
          value === true
            ? this.userType === 'Internal'
              ? true
              : false
            : false;
      });


    /**
     * Get existing notifications
     */
    this.getNewNotification();


    /**
     * Existing SignalR flag
     *
     * This can remain temporarily if
     * other code depends on it.
     */
    if (
      Number(
        sessionStorage.getItem(
          'IscallSignalR'
        ) || '0'
      ) === 0
    ) {

      sessionStorage.setItem(
        'IscallSignalR',
        '1'
      );
    }
  }


  /**
   * IMPORTANT:
   *
   * Do NOT use pagehide/pageshow
   * for SignalR here.
   *
   * SignalR is owned by
   * NotificationSignalRService.
   */


  ngOnDestroy() {

    /**
     * Header is being destroyed,
     * but SignalR MUST remain alive.
     */
    if (this.APItimeOUT) {

      clearTimeout(
        this.APItimeOUT
      );
    }
  }


  /**
   * Session timeout
   */
  sessionTimeout() {

    this.common.setTimeoutValue(true);

    sessionStorage.clear();

    this.router.navigate([
      'login'
    ]);
  }


  /**
   * Logout popup
   */
  public showLogoutPopup() {

    this.logoutClicked = true;
  }


  /**
   * Appointment dashboard
   */
  public gotoAppointmentDash() {

    const userType =
      this.common.getUserType();

    switch (userType) {

      case 'Internal':

        this.router.navigate([
          'dashboard/internal'
        ]);

        this.common
          .setInternalDashboardTab(true);

        break;


      case 'External':

        this.common
          .setExternalDashboardTab(true);

        this.router.navigate([
          'dashboard/external'
        ]);

        break;
    }
  }


  /**
   * Logout
   */
  public logout() {

    this.logoutHeader =
      !this.logoutHeader;
  }


  /**
   * Close logout popup
   */
  public closeLogout(event) {

    this.logoutClicked =
      event;

    this.logoutHeader = false;
  }


  /**
   * Logo click
   */
  public logoClicked() {

    this.gotoAppointmentDash();
  }


  /**
   * Close dropdown
   */
  public closeDropdown(event: Event) {

    this.logoutHeader = false;
  }


  /**
   * Search page
   */
  public gotoSearchPage() {

    this.router.navigate([
      'dashboard/external/today-dashboard/request-appointment'
    ]);
  }


  /**
   * Read notifications
   */
  public readNotificationsList() {

  this.loader.startLoader();

  let url = ApiUrlConstants.URL.readNotificationURL;

  url = url.replace(
    'USER_KEY',
    this.userID
  );

  this.api.ExecuteGet(
    url,
    (response) => {

      if (
        response &&
        response.ResponseCode === 200
      ) {

        // Mark badge count as zero
        sessionStorage.setItem(
          'unreadNotification',
          '0'
        );

        this.common.signalTotalCountSource.next(0);

        // IMPORTANT:
        // Tell ListingComponent to reload latest notifications
        this.common.setCallValue(true);

        // Navigate to notification listing page
        this.router.navigate([
          'dashboard/common/notifications/listing'
        ]);
      }

      this.loader.stopLoader();

    },
    (error) => {

      console.error(
        'Error reading notifications:',
        error
      );

      this.loader.stopLoader();
    }
  );
}


  /**
   * Get new notifications
   */
  public getNewNotification() {

    const url =
      ApiUrlConstants.URL
        .receiveNotificationURL;


    const currentDate =
      new Date();


    const currentDateMinute =
      currentDate.getMinutes() - 40;


    const startDate =
      new Date();


    const startDateMinute =
      startDate.setMinutes(
        currentDateMinute
      ) - 40;


    const currentTDateTime =
      new Date().toISOString();


    const startTDateTime =
      new Date(
        startDateMinute
      ).toISOString();


    const requestBody = {

      User: this.userID,

      StartDate:
        startTDateTime,

      EndDate:
        currentTDateTime
    };


    this.api.ExecutePost(
      url,
      requestBody,
      (response) => {

        if (
          response.ResponseCode === 200
        ) {

          this.notificationData =
            response.Data;


          this.totalUnreadRecords =
            response.Data
              .totalUnreadRecords;


          if (
            response.Data
              .totalUnreadRecords > 0 &&
            this.router.url ===
              '/dashboard/common/notifications/listing'
          ) {

            if (
              response.Data
                .totalUnreadRecords !==
              JSON.parse(
                sessionStorage.getItem(
                  'unreadNotification'
                )
              )
            ) {

              this.common.setCallValue(
                true
              );
            }
          }


          if (
            sessionStorage.getItem(
              'unreadNotification'
            ) &&
            JSON.parse(
              sessionStorage.getItem(
                'unreadNotification'
              )
            ) !== 0
          ) {

            if (
              response.Data
                .totalUnreadRecords >
              JSON.parse(
                sessionStorage.getItem(
                  'unreadNotification'
                )
              )
            ) {

              sessionStorage.setItem(
                'unreadNotification',
                response.Data
                  .totalUnreadRecords
              );
            }

          } else {

            if (
              response.Data
                .totalUnreadRecords > 0
            ) {

              sessionStorage.setItem(
                'unreadNotification',
                response.Data
                  .totalUnreadRecords
              );
            }
          }
        }
      },
      (error) => {

      }
    );
  }


  /**
   * Close notification
   */
  public closeNotification() {

    this.notificationBar = false;

    this.common
      .signalNotificationBarSource
      .next(false);

    clearTimeout(
      this.toasterTimeout
    );
  }


  /**
   * Automatically hide notification
   */
  public closeNotificationInterval() {

    this.toasterTimeout =
      setTimeout(() => {

        this.notificationBar =
          false;

        this.common
          .signalNotificationBarSource
          .next(false);

      }, 5000);
  }
}